import { render, staticRenderFns } from "./Ic_tabsCard.vue?vue&type=template&id=c0629bbe&"
import script from "./Ic_tabsCard.vue?vue&type=script&lang=js&"
export * from "./Ic_tabsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports